<template>
  <FormComponent
    :dialog="dialog"
    :config="config"
    :valid="valid"
    @save:form="saveConfig"
    @update:dialog="dialog = $event"
    @update:valid="valid = $event"
    @load:init-data="handleInitData"
    @clear:form="clear($event)"
  >
    <template v-slot:custom-fields>
      <v-autocomplete
        outlined
        dense
        color="secondary"
        item-color="secondary"
        v-model="config.filter.entity"
        :items="entities"
        :rules="selectRule"
        clearable
      >
        <template v-slot:label>
          {{ $t("widgets.dialogs.filters.entity") }}
          <strong class="red--text">*</strong>
        </template>
        <template v-slot:item="{ item, attrs }">
          {{$t('modules.name.' + item).toUpperCase()}}
        </template>
        <template v-slot:selection="{ item, index }">
          <v-chip v-if="index === 0" small>
            <span>{{
                $t("modules.name." + item).toUpperCase() | truncate(18)
              }}</span>
          </v-chip>
        </template>
      </v-autocomplete>
      <v-select
        v-if="config.filter.entity === 'StorageDevice'"
        v-model="config.filter.classificationType"
        :items="classifications"
        :label="$t('storage.fields.classificationType')"
        item-value="id"
        item-text="name"
        item-color="secondary"
        color="secondary"
        outlined
        dense
        clearable
      />
    </template>
  </FormComponent>
</template>

<script>
  import FormComponent from "@/module/dashboard/components/common/FormComponent.vue"
  import ColorPicker from "@/module/dashboard/components/common/ColorPicker.vue"
  import IconPicker from "@/module/dashboard/components/common/IconPicker.vue"
  import { FormWidgetMixin } from "@/module/dashboard/mixins/form-widget.mixin"
  import { mapGetters } from "vuex"
  import i18n from "@/plugins/i18n"

  export default {
    name: "CountDialog",
    components: { FormComponent, IconPicker, ColorPicker },
    mixins: [FormWidgetMixin],
    props: {
      item: {
        type: Object,
        required: false,
        default: () => ({
          id: null,
          title: i18n.t('widgets.names.COUNT'),
          icon: 'mdi-card-bulleted',
          color: '#232323',
          filter: {
            entity: null,
            classificationType: null,
          },
          format: {
            region: null,
            afterPoint: null
          },
          subtype: "COUNT",
          type: "CARD",
        }),
      },
    },
    data() {
      return {
        dialog: false,
        valid: false,
        config: {
          id: null,
          title: i18n.t('widgets.names.COUNT'),
          icon: 'mdi-card-bulleted',
          color: '#232323',
          filter: {
            entity: null,
            classificationType: null,
          },
          format: {
            region: null,
            afterPoint: null
          },
          subtype: "COUNT",
          type: "CARD",
        },
        entities: [
          "Record",
          "Document",
          "Location",
          "StorageDevice",
          "Culture",
          "Season",
          "Input",
          "Operator",
          "Equipment",
          "Survey",
        ],
        rules: {
          title: [v => !!v || i18n.t("widgets.dialogs.rules.required.title")],
          icon: [v => !!v || i18n.t("widgets.dialogs.rules.required.icon")],
        },
        defaultConfig: null
      }
    },
    watch: {
      valid() {
        this.$emit("update:validation", this.valid)
      },
    },
    async created() {
      this.defaultConfig = { ...this.config }
      this.config = {
        ...this.item.props,
        format: this.item.props.format || {
          region: null,
          afterPoint: null
        },
        subtype: "COUNT",
        icon: "mdi-card-bulleted",
        info: "COUNT",
      }

      await this.loadDependenciesByCard(this.item.type, this.item.subtype, this.config.filter.entity)
    },
    computed: {
      ...mapGetters({
        classifications: "storage/GET_CLASSIFICATIONS",
      }),
      isEditingEnabled() {
        return this.$store.getters["dashboard/IS_EDITING_MODE"]
      },
    },
    methods: {
      saveConfig(data) {
        const config = {
          ...data,
          filter: {
            entity: this.config.filter.entity,
            classificationType: this.getByProperty(this.config.filter.classificationType, "id"),
          },
          initialized: true,
        }

        this.$emit("update:config", config)
        this.$emit("update:validation", this.valid)
        this.dialog = false
      },
      async handleInitData() {
        if (this.item.initialized) {

          console.log(this.config)

          this.config.filter.classificationType = _.find(this.classifications, {
            id: this.getByProperty(this.config.filter.classificationType, "id"),
          })
        } else {
          this.config = { ...this.defaultConfig };
        }
      },
      clear(e) {
        this.config = { ...e }
      },
    },
  }
</script>

<style scoped></style>